export default __webpack_public_path__ + "static/media/makeitpop.1f92efce.png";